/**
 * Dónde NO sale el asistente flotante.
 *
 * Hasta agosto de 2026 esta lista tenía nueve rutas: todas las que montan la tabla dinámica, que
 * llevaban su propio panel de IA en el lateral y no querían dos asistentes en la misma pantalla.
 * Al retirar ese panel para unificarlo todo en un solo asistente, la lista se quedó al revés de
 * como debía: esconder el botón en las páginas de tabla las dejaba sin ninguna IA. Por eso ahora
 * encoge en vez de crecer.
 *
 * Fuera del login, donde no hay sesión con la que preguntar nada, y de `/asistente`, que es el
 * propio asistente ya abierto de página completa: un fab flotante encima de esa página no abriría
 * nada nuevo.
 */
export const ASSISTANT_HIDDEN_ROUTES: readonly string[] = [
  '/login',
  '/asistente',
] as const;

/**
 * Si el asistente debe esconderse en esta ruta.
 *
 * La comparación es exacta salvo la barra final, y no por prefijo, porque `/vigilancia` y
 * `/vigilancia-informe` son páginas distintas: la primera lleva la tabla y la segunda no. Un
 * `startsWith` escondería el asistente en las dos.
 */
export function isAssistantHiddenOn(pathname: string): boolean {
  const normalized = pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;
  return ASSISTANT_HIDDEN_ROUTES.includes(normalized);
}

/**
 * Preguntas de ejemplo para el estado vacío.
 *
 * En un solo sitio para que el mini-chat y la página completa muestren las mismas — antes vivían
 * copiadas dentro de `AssistantPanel.tsx` y sólo las veía el mini-chat.
 */
export const ASSISTANT_SUGGESTIONS: readonly string[] = [
  'Cuántas visitas se hicieron la semana pasada',
  'Qué zona tuvo más producción este mes',
  'Compara la producción de este mes con el anterior',
  'Qué actividades tuvo la sede con más visitas',
] as const;
